import {usePropsSelector} from '../../state/hooks';
import {ProjectPageViewSpec} from '../../state/views/projectPage/types';
import * as WorkspaceSelectors from '../../state/workspaces/selectors';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {useInitWorkspaceAndHandleUrlChanges} from '../../state/workspaces/url';
import {useDetectChanges} from '../../util/react-help/detectReactPropChanges';

export type ViewType = 'project-view' | 'sweep-view' | 'group-view';
export type RecommendGrouping = 'group-and-jobtype' | 'jobtype';

export const useMultiRunWorkspaceProps = (args: {
  entityName: string;
  projectName: string;
  viewType: ViewType;
  defaultSpec: ProjectPageViewSpec;
  workspaceObjectID?: string;
}): WorkspaceSelectors.WorkspaceStatusOrData<
  WorkspaceSelectors.MultiRunWorkspacePageData &
    WorkspaceSelectors.GenericWorkspacePageData & {
      workspaceID: string;
    }
> => {
  const workspaceStateId = useInitWorkspaceAndHandleUrlChanges(args);

  useDetectChanges('useMultiRunWorkspaceProps', {
    workspaceStateId,
    argsViewType: args.viewType,
    args,
  });

  const runPageData = usePropsSelector(
    WorkspaceSelectors.makeMultiRunWorkspacePageSelector,
    workspaceStateId,
    args.viewType
  );
  if (WorkspaceSelectors.getStatus(runPageData) !== 'ready') {
    return runPageData as WorkspaceSelectors.WorkspaceStatus;
  }

  if (!runPageData || !workspaceStateId) {
    console.error(
      'invalid state - workspace or workspaceID not set after loading'
    );
    return {
      status: 'error',
      error: {
        errorCode: '404',
        userTitle: 'Error loading workspace',
        userMessage: 'This workspace could not be loaded.',
      },
    };
  }

  return {...runPageData, workspaceID: workspaceStateId};
};
